export const Project = {
  Name: "WORK ASSIGNMENT",
  ServiceNowUrl:"https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=427534261b7e2150f0540edbdc4bcb8d",
  SupportEmail:"PaperlessMaintainerSupport@riotinto.com", 
  ReplacementTextForWO:":WorkOrderId",
  ReplacementTextForNotification:":NotificationId",
  ReplacementTextForSAPClient:":SAPClientId"
};
